module.exports = __webpack_public_path__ + "static/media/Genius Jain.69429a52.jpeg";